import React, { useEffect, useState } from "react";
import {
  convertLocalDate,
  convertProfileLocalDate,
} from "../../Utils/configController";
import * as url from "../../helpers/url_helper";
import { useParams } from "react-router-dom";
import ReactDataTable from "../../components/Common/ReactDataTable";
import {
  Collapse,
  Card,
  CardBody,
  Col,
  Row,
  Spinner,
  Button,
  CardHeader,
  Badge,
} from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useSocket } from "../../Utils/socket";
import { OPERATE_MQTT } from "../../helpers/socketEvent";
import { FormatJsonCheckBox } from "../../components/Common/button";
import Request from "../../helpers/request";
import OtaModal from "./Users/ProfileList/OtaModal";

const DebugDetail = () => {
  const socket: any = useSocket();
  const { slave } = useParams();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const [isReload, setReload] = useState(false);
  const [showFormatted, setShowFormatted] = useState<boolean>(false);
  const [txCount, setTxCount] = useState<number>(0);
  const [rxCount, setRxCount] = useState<number>(0);
  const [cmdCounts, setCmdCounts] = useState({});

  const [loading, setLoading] = useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<any[]>([]);
  const [deviceDetails, setDeviceDetails] = useState<any>({});

  const [isOpen, setIsOpen] = useState(true);
  const [isOtaOpen, setIsOtaOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const getUsersDetail = () => {
    setLoading(true);
    const reqObj = {
      slave: slave,
    };
    Request.post(url.FINDUSERBYSLAVE, reqObj)
      .then((res) => {
        const data = res?.data?.userDetail;
        setDeviceDetails(res?.data?.deviceInfo);
        setProfileDetails([
          {
            name: "User Id",
            data: `#${data?.id}`,
          },
          {
            name: "Name",
            data: `${data?.firstname} ${data?.lastname}`,
          },
          {
            name: "Email",
            data: data?.email ? data?.email : "--",
          },
          {
            name: "Mobile",
            data: data?.mobile ? data?.mobile : "--",
          },
          {
            name: "Address",
            data: data?.address ? data?.address : "--",
          },
          {
            name: "Created At",
            data: data?.createdAt
              ? convertProfileLocalDate(data?.createdAt)
              : "--",
          },
          {
            name: "Last login",
            data: data?.lastLogin
              ? convertProfileLocalDate(data?.lastLogin)
              : "--",
          },
          {
            name: "Last Action",
            data: data?.lastAction
              ? convertProfileLocalDate(data?.lastAction)
              : "--",
          },
          {
            name: "Last Online Time",
            data: data?.lastOnlineTime
              ? convertProfileLocalDate(data?.lastOnlineTime)
              : "--",
          },
          {
            name: "Last Offline Time",
            data: data?.lastOfflineTime
              ? convertProfileLocalDate(data?.lastOfflineTime)
              : "--",
          },
        ]);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUsersDetail();
  }, [slave]);

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const columns = [
    {
      name: "Command",
      cell: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          const cmd = parsed.cmd ? parsed.cmd : "-";

          const isTX = row.topic.includes("/TX") || row.topic.includes("/g2m");
          const isRX = row.topic.includes("/RX") || row.topic.includes("/m2g");

          const textColor = isTX ? "green" : isRX ? "orange" : "inherit";

          return <div style={{ color: textColor }}>{cmd}</div>;
        } catch (e) {
          return "-";
        }
      },
      selector: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          return parsed.cmd || "";
        } catch (e) {
          return "";
        }
      },
      sortable: true,
      wrap: true,
      grow: 0.5,
    },
    {
      name: `TX (${txCount})`,
      cell: (row: any) => {
        const isDevice =
          row.topic.includes("/TX") || row.topic.includes("/g2m");
        const content = isDevice
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
              lineHeight: "1.4",
              fontSize: "14px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },
    {
      name: `RX (${rxCount})`,
      cell: (row: any) => {
        const isMobile =
          row.topic.includes("/RX") || row.topic.includes("/m2g");
        const content = isMobile
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },

    {
      name: "Created At",
      selector: (row: any) => row.createdAt, // raw date value
      sortable: true,
      format: (row: any) => convertLocalDate(row.createdAt), // formatted display
      wrap: true,
    },
  ];

  const formatCommand = (command: string) => {
    try {
      return JSON.stringify(JSON.parse(command), null, 2);
    } catch {
      return command;
    }
  };

  const handlePG = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${slave}`);
    }
  };

  const handleDS = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DS",
      };

      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`DS sent to slave ${slave}`);
    }
  };
  const handleDL = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DL",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`DL sent to slave ${slave}`);
    }
  };
  const handleSS = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "SS",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`SS sent to slave ${slave}`);
    }
  };
  const handleGN = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "GN",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`GN sent to slave ${slave}`);
    }
  };
  const handleGG = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "GG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`GG sent to slave ${slave}`);
    }
  };
  const handleGC = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "GC",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`GC sent to slave ${slave}`);
    }
  };
  const handleReboot = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "HW",
        sub_cmd: "reboot",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Reboot sent to slave ${slave}`);
    }
  };

  const handleBSCH = () => {
    if (slave !== undefined && deviceDetails?.token) {
      const reqObj = {
        device_id: slave,
        cmd: "BSCH",
        sub_cmd: "get_info",
        tag: `airpanel-${userInfo?.id}`,
        token: deviceDetails?.token,
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`BSCH sent to slave ${slave}`);
    }
  };
  const handleBSCN = () => {
    if (slave !== undefined && deviceDetails?.token) {
      const reqObj = {
        device_id: slave,
        cmd: "BSCN",
        sub_cmd: "get_info",
        tag: `airpanel-${userInfo?.id}`,
        token: deviceDetails?.token,
      };

      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`BSCN sent to slave ${slave}`);
    }
  };
  const handleBRBT = () => {
    if (slave !== undefined && deviceDetails?.token) {
      const reqObj = {
        device_id: slave,
        cmd: "BRBT",
        tag: `airpanel-${userInfo?.id}`,
        token: deviceDetails?.token,
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`BRBT sent to slave ${slave}`);
    }
  };

  const openOtaModal = () => {
    if (!deviceDetails?.slave && !slave) {
      toast.error("Slave not found");
      return;
    }
    setIsOtaOpen(true);
  };
  return (
    <>
      <ToastContainer />
      {isOtaOpen && (
        <OtaModal
          headerTitle="OTA Update"
          otaSlave={{
            ...deviceDetails,
            slave: deviceDetails?.slave || slave,
            product:
              deviceDetails?.deviceType === "blaster"
                ? "airblaster"
                : deviceDetails?.product?.toLowerCase(),
          }}
          cancleBtnClick={() => setIsOtaOpen(false)}
          isHideLog={true}
        />
      )}
      <Card
        style={{
          marginTop: 100,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 0,
        }}
      >
        <CardHeader
          className="d-flex justify-content-between align-items-center px-4 py-3"
          style={{
            backgroundColor: "#fff",
            borderBottom: isOpen ? "1px solid #e9ecef" : "none",
          }}
        >
          {/* LEFT */}
          <div className="">
            {(() => {
              const DEVICE_ACTIONS: Record<string, any[]> = {
                chip: [
                  { label: "PG", onClick: handlePG },
                  { label: "DS", onClick: handleDS },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                  {
                    label: "Reboot",
                    onClick: handleReboot,
                    color: "danger",
                  },
                ],
                blaster: [
                  { label: "BSCH", onClick: handleBSCH },
                  { label: "BSCN", onClick: handleBSCN },
                  { label: "BRBT", onClick: handleBRBT },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                ],
                aircurtain: [
                  { label: "PG", onClick: handlePG },
                  { label: "DS", onClick: handleDS },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                  {
                    label: "Reboot",
                    onClick: handleReboot,
                    color: "danger",
                  },
                ],
                iotdevice: [
                  { label: "PG", onClick: handlePG },
                  { label: "DS", onClick: handleDS },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "OTA", onClick: openOtaModal, color: "primary" },
                  {
                    label: "Reboot",
                    onClick: handleReboot,
                    color: "danger",
                  },
                ],
                airgateway: [
                  { label: "PG", onClick: handlePG },
                  { label: "DL", onClick: handleDL },
                  { label: "SS", onClick: handleSS },
                  { label: "GN", onClick: handleGN },
                  { label: "GG", onClick: handleGG },
                  { label: "GC", onClick: handleGC },
                ],
              };
              const deviceType = deviceDetails?.deviceType?.toLowerCase();

              const actions = DEVICE_ACTIONS[deviceType || ""] || [];

              return (
                <div className="d-flex flex-wrap gap-3">
                  {actions.map((btn, index) => (
                    <button
                      key={index}
                      className={`btn btn-${btn.color || "dark"}`}
                      onClick={btn.onClick}
                      // disabled={!deviceDetails?.isOnline}
                    >
                      {btn.label}
                    </button>
                  ))}
                </div>
              );
            })()}
          </div>

          {/* RIGHT BUTTON */}
          <Button
            color="btn btn-dark"
            size="sm"
            onClick={toggle}
            className="  d-flex align-items-center gap-2"
          >
            <i
              className={`bx ${isOpen ? "bx-chevron-up" : "bx-chevron-down"}`}
              style={{ fontSize: "24px" }}
            ></i>
          </Button>
        </CardHeader>
        <Collapse isOpen={isOpen}>
          <CardBody>
            <Row>
              {profileDetails?.length > 0 && !loading ? (
                <>
                  <Col xs={12} md={3}>
                    {profileDetails
                      .slice(0, 5)
                      .map((item: any, index: number) => (
                        <p
                          key={index}
                          style={{ color: "#858D9D", fontSize: 14 }}
                          className="my-2"
                        >
                          {item?.name}:{" "}
                          {item?.name === "User Id" ? (
                            (() => {
                              const userId = item?.data?.startsWith("#")
                                ? item.data.slice(1)
                                : item?.data;

                              return (
                                <a
                                  href={`/users/profile/${userId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item?.data}
                                </a>
                              );
                            })()
                          ) : (
                            <span style={{ fontWeight: "bold", color: "#000" }}>
                              {item?.data}
                            </span>
                          )}
                        </p>
                      ))}
                  </Col>
                  <Col xs={12} md={3}>
                    {profileDetails
                      .slice(5, 10)
                      .map((item: any, index: number) => (
                        <p
                          key={index}
                          style={{ color: "#858D9D", fontSize: 14 }}
                          className="my-2"
                        >
                          {item?.name}:{" "}
                          <span style={{ fontWeight: "bold", color: "#000" }}>
                            {item?.data}
                          </span>
                        </p>
                      ))}
                  </Col>
                  <Col xs={12} md={6}>
                    <Card className="shadow-sm border-1 mb-0">
                      {/* HEADER */}
                      <CardHeader className="d-flex justify-content-between align-items-center bg-white pt-3 px-3">
                        <div>
                          <h5 className="mb-0 fw-semibold d-flex align-items-center gap-2">
                            <i className="bx bx-chip"></i>
                            {deviceDetails.slave}
                            <span className="text-muted">
                              ({deviceDetails.deviceType})
                            </span>
                          </h5>
                        </div>

                        <Badge
                          color={deviceDetails.isOnline ? "success" : "danger"}
                        >
                          {deviceDetails.isOnline ? "Online" : "Offline"}
                        </Badge>
                      </CardHeader>

                      {/* BODY */}
                      <CardBody className="py-2 px-3">
                        <div className="row g-2" style={{ fontSize: "13px" }}>
                          {/* LEFT COLUMN */}
                          <div className="col-6 row g-1">
                            <div>
                              <strong>Product:</strong>{" "}
                              {deviceDetails.product || "--"}
                            </div>
                            <div>
                              <strong>Model:</strong>{" "}
                              {deviceDetails.modelType || "--"}
                            </div>

                            <div>
                              <strong>HW:</strong>{" "}
                              {deviceDetails.hwVersion || "--"}
                            </div>
                            <div>
                              <strong>WiFi:</strong>{" "}
                              {deviceDetails.wifiVersion || "--"}
                            </div>
                          </div>

                          {/* RIGHT COLUMN */}
                          <div className="col-6 row g-1">
                            <div>
                              <strong>SSID:</strong>{" "}
                              {deviceDetails.ssid || "--"}
                            </div>
                            <div>
                              <strong>Signal:</strong>{" "}
                              <span
                                style={{
                                  color:
                                    deviceDetails.signalStrength > 80
                                      ? "green"
                                      : deviceDetails.signalStrength > 50
                                      ? "orange"
                                      : "red",
                                }}
                              >
                                {deviceDetails.signalStrength}%
                              </span>
                            </div>

                            <div>
                              <strong>THW:</strong> {deviceDetails.thw || "--"}
                            </div>
                            <div>
                              <strong>TSW:</strong> {deviceDetails.tsw || "--"}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </>
              ) : (
                <Col
                  xs={12}
                  md={12}
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "155px" }}
                >
                  <Spinner color="dark" />
                </Col>
              )}
            </Row>
          </CardBody>
        </Collapse>
      </Card>

      <ReactDataTable
        apiURL={`${url.BASE_URL}${url.DEBUG_DETAIL_LIST}`}
        paramsId={{ slave: slave }}
        columns={columns}
        isReload={isReload}
        setTxCount={setTxCount}
        setRxCount={setRxCount}
        setCmdCounts={setCmdCounts}
        cmdList={
          <div
            className="d-flex flex-wrap"
            style={{ gap: "12px", fontSize: "16px" }}
          >
            {Object.entries(cmdCounts as { [key: string]: number })
              ?.sort(([a], [b]) => {
                if (a === "ERROR") return 1;
                if (b === "ERROR") return -1;
                if (a === "NO CMD") return 1;
                if (b === "NO CMD") return -1;
                return a.localeCompare(b);
              })
              ?.map(([cmd, count], i) => (
                <div
                  key={`${cmd}-${i}`}
                  className={`d-flex justify-content-center align-items-center border gap-2 px-2 py-2 ${
                    cmd === "ERROR"
                      ? "bg-danger text-white rounded"
                      : "bg-light rounded"
                  }`}
                  style={{
                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                  }}
                >
                  <small className="text-uppercase fw-semibold">
                    {cmd === "ERROR" ? "ERRORS" : cmd}
                  </small>
                  <span className="badge bg-primary rounded-pill ">
                    {count}
                  </span>
                </div>
              ))}
          </div>
        }
        buttonformatJSON={
          <FormatJsonCheckBox
            checked={showFormatted}
            onChange={() => setShowFormatted(!showFormatted)}
          />
        }
      />
    </>
  );
};

export default DebugDetail;
